export default {
    'name': 'fullText',
    'label': 'patent-view.fulltext',
    'version': '1.0',
    'getComponent': () => import('./FullText.vue'),
    'tabIndex': 3,
    'left': true,
    'right': true,
    'singleView': false,
    'enableDensity': true,
};
